import { render } from "./ChatMessageList.vue?vue&type=template&id=b805790e"
const script = {}

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__